import { render, staticRenderFns } from "./NonConformityCreateUpdate.vue?vue&type=template&id=4a333322&"
import script from "./NonConformityCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./NonConformityCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityCreateUpdate.vue?vue&type=style&index=0&id=4a333322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports